import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import i18next from "i18next";
import { UpdateSystemTerm } from "services/systemTerms";

export default function useUpdateSystemTerm() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(UpdateSystemTerm, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            type: "success",
            message:
              i18next.language === "ar"
                ? "تم التعديل بنجاح"
                : "Updated successfully",
          });
          queryClient.invalidateQueries("system-terms");
        }
      },
    }),
  };
}
